var _mask, _rect, _mask2, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimilarstories({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_103_2104",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4.75,
    width: 17.5,
    height: 7,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4.75,
    width: 17.5,
    height: 7,
    rx: 1,
    stroke: "black",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_103_2104)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_103_2104",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 17.5,
    height: 7,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 17.5,
    height: 7,
    rx: 1,
    stroke: "black",
    strokeWidth: 3,
    mask: "url(#path-2-inside-2_103_2104)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.75H21",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24H21",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5H18",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 25.75H12",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimilarstories);
export default __webpack_public_path__ + "static/media/Similarstories.809cf19f29933fd4de62d6c41ecf7cce.svg";
export { ForwardRef as ReactComponent };